import styled from "@emotion/styled";

const LeadFormInput = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 24px 0;
    > div {
      flex-basis: 100%;
      margin-bottom: 16px;
  
      &:nth-of-type(3) {
        flex: 30% 1 0;
      }
    
      &:nth-of-type(2) {
        flex-basis: 30%;
        margin-right: 16px;
        @media ${props => props.theme.mobile} {
            margin-right: 0;
            flex-basis: 100%;
        }
      }
      
      &:last-of-type {
        margin-bottom: 0;
      }
    }
`;

export default LeadFormInput;
